module.exports = __webpack_public_path__ + "static/media/photo17.94d0e35a.jpg";